import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translation files
import enCommon from "./locale/en/common.json";
import frCommon from "./locale/fr/common.json";
import enAbandonedCalls from "./locale/en/abandonedCalls.json";
import frAbandonedCalls from "./locale/fr/abandonedCalls.json";
import enMessageSentReceived from "./locale/en/messageSentReceived.json";
import frMessageSentReceived from "./locale/fr/messageSentReceived.json";
import enDailyCheckoutReport from "./locale/en/dailyCheckoutReport.json";
import frDailyCheckoutReport from "./locale/fr/dailyCheckoutReport.json";

const resources = {
  en: {
    common: enCommon,
    abandonedCalls: enAbandonedCalls,
    messageSentReceived: enMessageSentReceived,
    dailyCheckoutReport: enDailyCheckoutReport,
  },
  fr: {
    common: frCommon,
    abandonedCalls: frAbandonedCalls,
    messageSentReceived: frMessageSentReceived,
    dailyCheckoutReport: frDailyCheckoutReport,
  },
};

i18n
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: "en", // Default language
    debug: false,
    interpolation: {
      escapeValue: false, // React already handles escaping
    },
    ns: ["common", "abandonedCalls", "messageSentReceived", "dailyCheckoutReport"], // Namespaces
    defaultNS: "common",
  });

export default i18n;
